import { Text } from "src/components/Text/Text.tsx";
import { css } from "@emotion/react";
import type { ClassAttributes, HTMLAttributes } from "react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

type PlusButtonProps = {
  disabled?: boolean;
} & HTMLAttributes<HTMLButtonElement> &
  ClassAttributes<HTMLButtonElement>;

export const PlusButton = ({
  disabled = false,
  ...restProps
}: PlusButtonProps) => {
  return (
    <button
      css={buttonStyles({
        disabled,
      })}
      disabled={disabled}
      {...restProps}
    >
      {/* @ts-ignore: typescript doesn't see nested colors */}
      <Text css={textStyles} variant="body2">
        <i className={"icon-15-add"} css={iconStyles} />
      </Text>
    </button>
  );
};

const buttonStyles =
  ({ disabled }: { disabled: boolean }) =>
  (theme: ExactTheme) => [
    css`
      border: none;
      background: transparent;
      cursor: ${disabled ? "not-allowed" : "pointer"};
      display: flex;
      align-items: center;
      position: relative;
      top: 1px;
      width: 25px;
      height: 25px;
      justify-content: center;
      border-radius: 13px;
      flex-shrink: 0;
      color: ${disabled ? theme.colorsV2.grey[500] : theme.colorsV2.fg.default};
    `,
    !disabled &&
      css`
        :hover {
          background: ${theme.colorsV2.grey[100]};
        }
        :focus-visible {
          background: ${theme.colorsV2.grey[200]};
        }
      `,
  ];

const textStyles = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const iconStyles = css`
  display: block;
`;
